import { Component, EventEmitter, HostListener, Output } from '@angular/core';

@Component({
    selector: 'app-bar-code-scanner',
    template: ``,
    styleUrls: [],
    standalone: true
})
export class BarCodeScannerComponent {

  private locked: boolean = false;
  private key: string = "";

  @Output() scanTriggered: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  @HostListener("window:keypress", ["$event"])
  async handleKeyDown(event: KeyboardEvent) {
    if (
      event.key != "Enter" &&
      event.key != "Escape" &&
      this.locked === false
    ) {
      this.key = this.key + event.key;
    }

    if (event.key == "Enter" && this.key != '' && this.key != null && this.key != undefined) {
      console.debug(`Barcode Scanned ${this.key}`);

      this.locked = true;
      this.scanTriggered.emit(this.key);
      
      this.key = "";
      this.locked = false;
    }
  }
}
